var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrencyIconEuro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "currency-icon_euro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003FD1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "euro_symbol_black_24dp",
    transform: "translate(8.000000, 9.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,25.8333333 C15.8166667,25.8333333 12.2,23.4666667 10.4,20 L20,20 L20,16.6666667 L9.3,16.6666667 C9.21666667,16.1166667 9.16666667,15.5666667 9.16666667,15 C9.16666667,14.4333333 9.21666667,13.8833333 9.3,13.3333333 L20,13.3333333 L20,10 L10.4,10 C12.2,6.53333333 15.8333333,4.16666667 20,4.16666667 C22.6833333,4.16666667 25.15,5.15 27.05,6.78333333 L30,3.83333333 C27.35,1.45 23.8333333,0 20,0 C13.4666667,0 7.93333333,4.18333333 5.86666667,10 L0,10 L0,13.3333333 L5.1,13.3333333 C5.03333333,13.8833333 5,14.4333333 5,15 C5,15.5666667 5.03333333,16.1166667 5.1,16.6666667 L0,16.6666667 L0,20 L5.86666667,20 C7.93333333,25.8166667 13.4666667,30 20,30 C23.85,30 27.35,28.55 30,26.1666667 L27.0333333,23.2166667 C25.15,24.85 22.7,25.8333333 20,25.8333333 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyIconEuro);
export default __webpack_public_path__ + "static/media/currency-icon_euro.19141058d8dda8a3d68983fbf38498f6.svg";
export { ForwardRef as ReactComponent };